import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface SupportIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const SupportIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: SupportIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M4.34874 14.5413L4.06174 14.8283H4.06188C3.83049 15.0595 3.70041 15.3732 3.70027 15.7003C3.70027 16.0275 3.83007 16.3412 4.06132 16.5725C4.29256 16.8039 4.60627 16.9339 4.93332 16.934H8.82326C9.3828 17.8777 10.1794 18.6587 11.1338 19.1996C12.0883 19.7404 13.1677 20.0223 14.2648 20.0174H18.5321H18.532C18.8443 20.0157 19.1432 19.8904 19.3633 19.6688C19.5832 19.4472 19.7064 19.1474 19.7059 18.8352C19.7053 18.5229 19.5809 18.2237 19.36 18.0029L19.1355 17.7808H19.1356C20.0184 16.7405 20.5037 15.4207 20.5053 14.0562C20.4905 12.7455 20.0431 11.4762 19.2328 10.446C18.4225 9.41559 17.2945 8.68179 16.0243 8.35831C15.5326 7.05961 14.6537 5.94354 13.5066 5.16115C12.3594 4.37876 10.9995 3.96774 9.61101 3.98413C7.85365 3.94614 6.15285 4.60629 4.88135 5.81996C3.60985 7.03364 2.8714 8.70192 2.82764 10.4591C2.82846 11.9582 3.36833 13.4071 4.34866 14.5414L4.34874 14.5413ZM19.2721 14.0562C19.2653 15.304 18.751 16.4953 17.8473 17.3558C17.729 17.4717 17.6624 17.6301 17.6624 17.7957C17.6624 17.9611 17.729 18.1197 17.8473 18.2354L18.4023 18.7838L14.265 18.784C12.7226 18.7892 11.2606 18.0971 10.2869 16.901C11.9232 16.7776 13.4551 16.0496 14.5842 14.8588C15.7132 13.6679 16.3585 12.0994 16.3946 10.4589C16.3939 10.2284 16.3807 9.99807 16.3551 9.76903C17.2092 10.1173 17.9416 10.7097 18.4606 11.4723C18.9795 12.235 19.2619 13.1337 19.2723 14.0561L19.2721 14.0562ZM9.6112 5.21739C10.7778 5.19936 11.9203 5.55105 12.8749 6.22196C13.8293 6.893 14.5472 7.84883 14.9252 8.95277C14.9283 8.96695 14.9322 8.98085 14.9367 8.99462C15.0843 9.46882 15.16 9.96243 15.1612 10.4591C15.1176 11.8891 14.509 13.2437 13.4688 14.226C12.4286 15.2084 11.0415 15.7387 9.61132 15.7007H4.93345L5.6422 14.9911C5.75906 14.8744 5.82417 14.7157 5.82293 14.5506C5.82169 14.3854 5.75425 14.2278 5.63573 14.1129C4.63447 13.1606 4.06569 11.8407 4.06115 10.459C4.10478 9.02887 4.71334 7.67428 5.75353 6.69173C6.79376 5.70933 8.18084 5.1791 9.61105 5.21723L9.6112 5.21739Z"
                fill={color}
            />
        </svg>
    )
}

export default SupportIcon
